
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34500',
  depVersions: {
  "documents-public-ui": "static-1.34500",
  "atom": "static-1.5069",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2495",
  "client-types": "static-1.466",
  "cssUtils": "static-1.791",
  "customer-data-filters-ui": "static-1.39754",
  "customer-data-objects": "static-1.7667",
  "customer-data-property-utils": "static-1.8087",
  "documents-lib": "static-1.34505",
  "emoji-mart": "static-3.4",
  "FormsCommonComponents": "static-1.85834",
  "FormUrlGenerator": "static-2.4715",
  "foundations-theming-specialty": "static-1.2130",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5591",
  "hs-test-utils": "static-1.8011",
  "hub-http": "static-1.6220",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11468",
  "I18n": "static-7.1625",
  "jasmine-immutable": "static-1.3019",
  "jasmine-runner": "static-1.6463",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7154",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5398",
  "quartz": "static-1.7029",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16669",
  "react-utils": "static-2.5340",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8169",
  "reference-resolvers-lite": "static-1.8092",
  "reporting-data": "static-1.67524",
  "reporting-reports": "static-1.67202",
  "reporting-snowflake": "static-1.56142",
  "reporting-testing-lib": "static-1.9457",
  "reporting-visualizations": "static-1.59600",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8940",
  "sanitize": "static-1.4474",
  "sanitize-text": "static-1.8139",
  "self-service-api": "static-1.10246",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1745",
  "signup-constants": "static-1.18830",
  "signup-ui-url-generator": "static-2.8044",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4759",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4761",
  "ui-addon-form-validation": "static-1.10989",
  "ui-asset-management-lib": "static-1.11026",
  "ui-images": "static-2.1153",
  "usage-tracker": "static-1.7341",
  "usage-tracker-container": "static-1.7331",
  "usage-tracker-core": "static-1.7191",
  "viral-links-lib": "static-1.7058",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9667",
  "flux-actions": "static-1.337",
  "foundations-components": "static-1.7930",
  "HubStyle": "static-2.11775",
  "icons": "static-2.646",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.397",
  "quartz-config": "static-1.807",
  "quartz-core": "static-1.6248",
  "quick-fetch": "static-1.3913",
  "raven": "static-3.5907",
  "react-select-plus": "static-1.105",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-ui-components": "static-2.64795",
  "rpc-client-utils": "static-1.4649",
  "transmute": "static-2.85",
  "ui-addon-i18n": "static-1.11148",
  "ui-addon-upgrades": "static-9.17986",
  "UIComponents": "static-3.8414",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3395",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3306",
  "quartz-webpack": "static-1.3253",
  "foundations-assets": "static-1.4863",
  "foundations-theming": "static-1.4414",
  "hub-http-shared-msw-handlers": "static-1.9953",
  "hubspotter-http": "static-1.4648",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.217",
  "conversations-skeleton-state": "static-1.7244",
  "crm-message-bus": "static-1.42976",
  "customer-data-filters-ui-msw-helpers": "static-1.22189",
  "customer-data-objects-ui-components": "static-1.13024",
  "customer-data-reference-ui-components": "static-1.13161",
  "customer-data-ui-utilities": "static-1.9823",
  "framework-builder-read-service-client": "static-1.4001",
  "framework-data-schema-quick-fetch": "static-1.6787",
  "framework-data-schema-resolvers": "static-1.6882",
  "inbound-db-meta-service-client": "static-1.3581",
  "inbound-db-properties-service-client": "static-1.3842",
  "multi-account-reference-resolvers": "static-1.978",
  "onboarding-tours": "static-1.16590",
  "reporting-datasets-permissions-lib": "static-1.13670",
  "ui-addon-teams": "static-1.21546",
  "quartz-auth": "static-1.704",
  "ui-business-units-lib": "static-1.9051",
  "usage-tracker-session-replay": "static-1.5027",
  "ai-components-ui-library": "static-1.8968",
  "ContentUtils": "static-1.68352",
  "customer-data-properties": "static-1.51535",
  "forms-ai-lib": "static-1.4316",
  "forms-utils-lib": "static-1.12578",
  "foundations-components-test-utils": "static-1.5413",
  "react-dnd-compat": "static-1.4613",
  "react-tinymce": "static-1.55231",
  "tinymce-config": "static-2.54357",
  "ui-gdpr-components": "static-1.10346",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3399",
  "HeadJS": "static-2.760",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3122",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.77",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4325",
  "csstype": "static-1.50",
  "quartz-head": "static-1.694",
  "web-vitals": "static-1.5",
  "batch-promise": "static-1.1538",
  "external-options-client-types": "static-1.4154",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.704",
  "frontend-preferences-client": "static-1.7926",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3695",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25367",
  "hubspot-apollo-client": "static-1.4876",
  "foundations-components-legacy": "static-1.955",
  "merchandise-lib": "static-1.263",
  "quartz-routing": "static-1.459",
  "hs-story-utils": "static-1.9423",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.224",
  "timezone-utils": "static-2.5241",
  "bend-plugin-foundations-components": "static-1.4199",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.23",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1926",
  "ui-fonts": "static-1.730",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.834",
  "mobile-manifest-mixins": "static-1.534",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.704",
  "quartz-tracking": "static-1.408",
  "reporting-action-components": "static-1.41297",
  "reporting-plugins": "static-1.10320",
  "bend-plugin-chirp-manifest": "static-1.59",
  "chirp-fetch": "static-1.1885",
  "purchase-motions-components": "static-1.5892",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4076",
  "bender-build-tools": "static-1.3199",
  "bend-plugin-foundations-theming": "static-1.2897",
  "stylex": "static-1.33",
  "hs-resources": "static-1.148",
  "pulse": "static-1.570",
  "restore-request-side-panel-lib": "static-1.883",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3793",
  "crm-pipelines-api-client-types": "static-1.4134",
  "fdsr-migration-layer": "static-1.1",
  "multi-currency-client-types": "static-1.3687",
  "getting-started-shared-tasks": "static-1.18467",
  "growth-data-modal": "static-1.5426",
  "growth-onboarding-confetti": "static-1.3064",
  "growth-onboarding-next-action-utils": "static-1.1905",
  "navigation-components": "static-1.18027",
  "onboarding-tours-client": "static-1.4804",
  "onboarding-tours-utils": "static-1.656",
  "ui-shepherd-react": "static-3.10161",
  "ui-shepherd-tracker": "static-1.7542",
  "ui-universal-auth": "static-1.8974",
  "user-context": "static-1.5101",
  "hubspotter-http-shared-msw-handlers": "static-1.9951",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21278",
  "copilot-toolkit": "static-1.11127",
  "cms-field-types": "static-1.4808",
  "content-icons-ui": "static-1.2226",
  "integrations-lib": "static-1.16111",
  "calling-global-api": "static-1.64499",
  "calling-internal-common": "static-1.31299",
  "calling-lifecycle-internal": "static-1.65881",
  "calling-lifecycle-messages": "static-1.58175",
  "commerce-products-lib": "static-1.9537",
  "crm-links": "static-1.6289",
  "customer-data-properties-shared-msw-handlers": "static-1.9280",
  "file-manager-components": "static-1.23617",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4219",
  "meetings-icalendar-utils-lib": "static-1.628",
  "object-builder-ui-client": "static-1.48731",
  "pipeline-validation-client-types": "static-1.3961",
  "property-value-citations": "static-1.2149",
  "smart-property-lib": "static-1.6983",
  "tiered-pricing": "static-1.1211",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9055",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19830",
  "tinymce-themes": "static-1.56327",
  "data-token-picker": "static-1.16407",
  "hub-http-contrib": "static-1.3040",
  "interframe": "static-3.4757",
  "tinymce-data": "static-1.40442",
  "tinymce-plugins": "static-1.57471",
  "ui-addon-sales-email": "static-1.5209",
  "onboarding-scopes": "static-1.6459",
  "ui-addon-opt": "static-4.8364",
  "apollo-link-hub-http": "static-2.4647",
  "hubspot-apollo-cache": "static-1.335",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.170",
  "content-assistance-lib": "static-1.7748",
  "dashboard-lib": "static-1.81519",
  "ExportDialog": "static-6.10387",
  "hubspot-prosemirror": "static-1.18226",
  "hubspot-prosemirror-plugins": "static-1.18218",
  "prosemirror": "static-1.13",
  "react-colorpicker": "static-2.10205",
  "share-with-third-party-component-lib": "static-1.8700",
  "campaign-roi-lib": "static-1.9101",
  "purchase-motions-api": "static-1.5895",
  "trials-service-types": "static-1.3901",
  "bend-plugin-pulse": "static-1.73",
  "directed-graph": "static-1.932",
  "event-emitter": "static-1.945",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1954",
  "growth-onboarding-next-action-components": "static-1.1933",
  "user-context-client": "static-1.4609",
  "idb-keyval": "static-1.44",
  "magpie-lib": "static-1.5550",
  "magpie-types": "static-1.5010",
  "nest": "static-1.222",
  "reactive-lib": "static-1.721",
  "simple-logging-lib": "static-1.3046",
  "unified-auth-core-lib": "static-1.770",
  "getting-started-shared-tasks-store": "static-1.17585",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13526",
  "integrations-tracking-lib": "static-1.5599",
  "native-integrations-shared-strings": "static-1.7780",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10364",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.488",
  "calling-error-reporting": "static-1.31306",
  "shared-worker-versioning": "static-1.11033",
  "calling-usage-tracker": "static-1.6538",
  "voice-sms-access-library": "static-1.962",
  "customer-data-tracking": "static-1.6885",
  "commerce-permissions": "static-1.766",
  "products-iframe-lib": "static-1.7920",
  "products-ui-components-shared-msw-handlers": "static-1.10335",
  "location-customization-utils-lib": "static-1.9242",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4152",
  "video-components-external": "static-1.11252",
  "video-data-lib": "static-1.34910",
  "data-agent-kit": "static-1.188",
  "feedback-loader": "static-1.29293",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10036",
  "fsm": "static-1.3728",
  "policy-lib": "static-1.6777",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10099",
  "navigation-messaging": "static-1.7354",
  "FileManagerLib": "static-1.39257",
  "NamespacedHubStyle": "static-2.9055",
  "FileManagerCore": "static-1.39116",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12445",
  "layout-dnd-utils": "static-1.11420",
  "react-codemirror": "static-1.10624",
  "ui-addon-emoji-picker": "static-1.9886",
  "ui-brand-identity-lib": "static-1.15262",
  "ui-addon-video-player": "static-1.8700",
  "ui-coaching-tips": "static-1.28544",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23522",
  "EmailSignatureEditor": "static-1.24363",
  "breeze-engine-lib": "static-1.623",
  "InboxConnectUtils": "static-4.14800",
  "meetings-connect-utils-lib": "static-1.7603",
  "universal-page-editor-lib": "static-1.3011",
  "google-sheets-integration-lib": "static-1.225",
  "microsoft-drive-integration-lib": "static-1.344",
  "calling-orchestration-schema": "static-1.35739",
  "sales-views-client-types": "static-1.4256",
  "crm-record-cards-service-types": "static-1.3593",
  "content-media-composition-data-lib": "static-1.12252",
  "content-media-compositions": "static-2.16259",
  "media-bridge-lib": "static-1.18924",
  "trellis-story-utils": "static-1.4514",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5912",
  "FileManagerImages": "static-1.36768",
  "video-components": "static-1.13255",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4534",
  "video-embed": "static-1.35744",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68427",
  "layout-data-lib": "static-1.9745",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6578",
  "commerce-tours-lib": "static-1.6091",
  "growth-onboarding-reliability": "static-1.5079",
  "sales-checkout-service-client": "static-1.3638",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21674",
  "sales-email-signature-service-client": "static-1.3840",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22091",
  "outpost": "static-1.4179",
  "advanced-menus-core": "static-1.15123",
  "advanced-menus-lib": "static-1.12065",
  "ui-memberships-settings-lib": "static-1.34035",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15122",
  "simple-menus-lib": "static-1.16639"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34500",
  "atom": "/atom/static-1.5069",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2495",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.791",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39754",
  "customer-data-objects": "/customer-data-objects/static-1.7667",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8087",
  "documents-lib": "/documents-lib/static-1.34505",
  "emoji-mart": "/emoji-mart/static-3.4",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85834",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4715",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2130",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5591",
  "hs-test-utils": "/hs-test-utils/static-1.8011",
  "hub-http": "/hub-http/static-1.6220",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11468",
  "I18n": "/I18n/static-7.1625",
  "jasmine-immutable": "/jasmine-immutable/static-1.3019",
  "jasmine-runner": "/jasmine-runner/static-1.6463",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7154",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5398",
  "quartz": "/quartz/static-1.7029",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16669",
  "react-utils": "/react-utils/static-2.5340",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8169",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8092",
  "reporting-data": "/reporting-data/static-1.67524",
  "reporting-reports": "/reporting-reports/static-1.67202",
  "reporting-snowflake": "/reporting-snowflake/static-1.56142",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9457",
  "reporting-visualizations": "/reporting-visualizations/static-1.59600",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8940",
  "sanitize": "/sanitize/static-1.4474",
  "sanitize-text": "/sanitize-text/static-1.8139",
  "self-service-api": "/self-service-api/static-1.10246",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1745",
  "signup-constants": "/signup-constants/static-1.18830",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8044",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4759",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4761",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10989",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11026",
  "ui-images": "/ui-images/static-2.1153",
  "usage-tracker": "/usage-tracker/static-1.7341",
  "usage-tracker-container": "/usage-tracker-container/static-1.7331",
  "usage-tracker-core": "/usage-tracker-core/static-1.7191",
  "viral-links-lib": "/viral-links-lib/static-1.7058",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9667",
  "flux-actions": "/flux-actions/static-1.337",
  "foundations-components": "/foundations-components/static-1.7930",
  "HubStyle": "/HubStyle/static-2.11775",
  "icons": "/icons/static-2.646",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "quartz-config": "/quartz-config/static-1.807",
  "quartz-core": "/quartz-core/static-1.6248",
  "quick-fetch": "/quick-fetch/static-1.3913",
  "raven": "/raven/static-3.5907",
  "react-select-plus": "/react-select-plus/static-1.105",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-ui-components": "/reporting-ui-components/static-2.64795",
  "rpc-client-utils": "/rpc-client-utils/static-1.4649",
  "transmute": "/transmute/static-2.85",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11148",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17986",
  "UIComponents": "/UIComponents/static-3.8414",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3395",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3306",
  "quartz-webpack": "/quartz-webpack/static-1.3253",
  "foundations-assets": "/foundations-assets/static-1.4863",
  "foundations-theming": "/foundations-theming/static-1.4414",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9953",
  "hubspotter-http": "/hubspotter-http/static-1.4648",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.217",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7244",
  "crm-message-bus": "/crm-message-bus/static-1.42976",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22189",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13024",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13161",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9823",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4001",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6787",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6882",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3581",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3842",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.978",
  "onboarding-tours": "/onboarding-tours/static-1.16590",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13670",
  "ui-addon-teams": "/ui-addon-teams/static-1.21546",
  "quartz-auth": "/quartz-auth/static-1.704",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5027",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8968",
  "ContentUtils": "/ContentUtils/static-1.68352",
  "customer-data-properties": "/customer-data-properties/static-1.51535",
  "forms-ai-lib": "/forms-ai-lib/static-1.4316",
  "forms-utils-lib": "/forms-utils-lib/static-1.12578",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5413",
  "react-dnd-compat": "/react-dnd-compat/static-1.4613",
  "react-tinymce": "/react-tinymce/static-1.55231",
  "tinymce-config": "/tinymce-config/static-2.54357",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10346",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3399",
  "HeadJS": "/HeadJS/static-2.760",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3122",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.77",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4325",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.694",
  "web-vitals": "/web-vitals/static-1.5",
  "batch-promise": "/batch-promise/static-1.1538",
  "external-options-client-types": "/external-options-client-types/static-1.4154",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.704",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7926",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3695",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25367",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4876",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.955",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "quartz-routing": "/quartz-routing/static-1.459",
  "hs-story-utils": "/hs-story-utils/static-1.9423",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.224",
  "timezone-utils": "/timezone-utils/static-2.5241",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4199",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.23",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1926",
  "ui-fonts": "/ui-fonts/static-1.730",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.834",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.534",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.704",
  "quartz-tracking": "/quartz-tracking/static-1.408",
  "reporting-action-components": "/reporting-action-components/static-1.41297",
  "reporting-plugins": "/reporting-plugins/static-1.10320",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.59",
  "chirp-fetch": "/chirp-fetch/static-1.1885",
  "purchase-motions-components": "/purchase-motions-components/static-1.5892",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4076",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2897",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.148",
  "pulse": "/pulse/static-1.570",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.883",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3793",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4134",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.1",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3687",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18467",
  "growth-data-modal": "/growth-data-modal/static-1.5426",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3064",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1905",
  "navigation-components": "/navigation-components/static-1.18027",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4804",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.656",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10161",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7542",
  "ui-universal-auth": "/ui-universal-auth/static-1.8974",
  "user-context": "/user-context/static-1.5101",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9951",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21278",
  "copilot-toolkit": "/copilot-toolkit/static-1.11127",
  "cms-field-types": "/cms-field-types/static-1.4808",
  "content-icons-ui": "/content-icons-ui/static-1.2226",
  "integrations-lib": "/integrations-lib/static-1.16111",
  "calling-global-api": "/calling-global-api/static-1.64499",
  "calling-internal-common": "/calling-internal-common/static-1.31299",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65881",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58175",
  "commerce-products-lib": "/commerce-products-lib/static-1.9537",
  "crm-links": "/crm-links/static-1.6289",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9280",
  "file-manager-components": "/file-manager-components/static-1.23617",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4219",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.628",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48731",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3961",
  "property-value-citations": "/property-value-citations/static-1.2149",
  "smart-property-lib": "/smart-property-lib/static-1.6983",
  "tiered-pricing": "/tiered-pricing/static-1.1211",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9055",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19830",
  "tinymce-themes": "/tinymce-themes/static-1.56327",
  "data-token-picker": "/data-token-picker/static-1.16407",
  "hub-http-contrib": "/hub-http-contrib/static-1.3040",
  "interframe": "/interframe/static-3.4757",
  "tinymce-data": "/tinymce-data/static-1.40442",
  "tinymce-plugins": "/tinymce-plugins/static-1.57471",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5209",
  "onboarding-scopes": "/onboarding-scopes/static-1.6459",
  "ui-addon-opt": "/ui-addon-opt/static-4.8364",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4647",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.335",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.170",
  "content-assistance-lib": "/content-assistance-lib/static-1.7748",
  "dashboard-lib": "/dashboard-lib/static-1.81519",
  "ExportDialog": "/ExportDialog/static-6.10387",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18226",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18218",
  "prosemirror": "/prosemirror/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.10205",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8700",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9101",
  "purchase-motions-api": "/purchase-motions-api/static-1.5895",
  "trials-service-types": "/trials-service-types/static-1.3901",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.73",
  "directed-graph": "/directed-graph/static-1.932",
  "event-emitter": "/event-emitter/static-1.945",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1954",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1933",
  "user-context-client": "/user-context-client/static-1.4609",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-lib": "/magpie-lib/static-1.5550",
  "magpie-types": "/magpie-types/static-1.5010",
  "nest": "/nest/static-1.222",
  "reactive-lib": "/reactive-lib/static-1.721",
  "simple-logging-lib": "/simple-logging-lib/static-1.3046",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.770",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17585",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13526",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5599",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7780",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10364",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.488",
  "calling-error-reporting": "/calling-error-reporting/static-1.31306",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11033",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6538",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.962",
  "customer-data-tracking": "/customer-data-tracking/static-1.6885",
  "commerce-permissions": "/commerce-permissions/static-1.766",
  "products-iframe-lib": "/products-iframe-lib/static-1.7920",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10335",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9242",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4152",
  "video-components-external": "/video-components-external/static-1.11252",
  "video-data-lib": "/video-data-lib/static-1.34910",
  "data-agent-kit": "/data-agent-kit/static-1.188",
  "feedback-loader": "/feedback-loader/static-1.29293",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10036",
  "fsm": "/fsm/static-1.3728",
  "policy-lib": "/policy-lib/static-1.6777",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10099",
  "navigation-messaging": "/navigation-messaging/static-1.7354",
  "FileManagerLib": "/FileManagerLib/static-1.39257",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9055",
  "FileManagerCore": "/FileManagerCore/static-1.39116",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12445",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11420",
  "react-codemirror": "/react-codemirror/static-1.10624",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9886",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15262",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8700",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28544",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23522",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24363",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.623",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14800",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7603",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3011",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.225",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.344",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35739",
  "sales-views-client-types": "/sales-views-client-types/static-1.4256",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3593",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12252",
  "content-media-compositions": "/content-media-compositions/static-2.16259",
  "media-bridge-lib": "/media-bridge-lib/static-1.18924",
  "trellis-story-utils": "/trellis-story-utils/static-1.4514",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5912",
  "FileManagerImages": "/FileManagerImages/static-1.36768",
  "video-components": "/video-components/static-1.13255",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4534",
  "video-embed": "/video-embed/static-1.35744",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68427",
  "layout-data-lib": "/layout-data-lib/static-1.9745",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6578",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6091",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5079",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3638",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21674",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3840",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22091",
  "outpost": "/outpost/static-1.4179",
  "advanced-menus-core": "/advanced-menus-core/static-1.15123",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12065",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34035",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15122",
  "simple-menus-lib": "/simple-menus-lib/static-1.16639"
}
};
